import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";

import Imagen1 from "../../../images/modulo13/altiplano.png";
import Imagen2 from "../../../images/modulo13/costa.png";
import Imagen3 from "../../../images/modulo13/selva.png";
import Imagen4 from "../../../images/modulo13/interandino.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad1.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "1" },
  });

  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[0];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${infoUnidad.name}: ${modulo13.content[0].activities[1].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[1].path}`,
    titlePrev: modulo13.title,
    linkPrev: modulo13.url,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa las imágenes de diferentes lugares del Perú.</li>
        <li>
          ¿Qué ves en cada una de ellas? Descríbelas siguiendo las indicaciones
          de tu profesor, profesora o familiar.{" "}
        </li>
        <li>
          ¿Cuáles de estos paisajes hay en tu departamento? Márcalos con un
          check.
        </li>
      </ul>

      <div className="row g-5 mt-3">
        <div className="col-lg-10 col-12 d-flex">
          <div className="row g-1 align-items-center">
            <div className="col-1 text-center">
              <input
                className={
                  "form-check-input mb-1 w-140 form-md " + answers.ans1.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans1.value === "1"}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
            </div>
            <div className="col-11">
              <img src={Imagen1} className="img-fluid" alt="Peruanos" />
            </div>
          </div>
        </div>
        <div className="col-lg-10 col-12 d-flex">
          <div className="row g-1 align-items-center">
            <div className="col-1 text-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans2.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans2.value === "1"}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
            </div>
            <div className="col-11">
              <img src={Imagen2} className="img-fluid" alt="Peruanos" />
            </div>
          </div>
        </div>
        <div className="col-lg-10 col-12 d-flex">
          <div className="row g-1 align-items-center">
            <div className="col-1 text-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans3.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans3.value === "1"}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
            </div>
            <div className="col-11">
              <img src={Imagen3} className="img-fluid" alt="Peruanos" />
            </div>
          </div>
        </div>
        <div className="col-lg-10 col-12 d-flex">
          <div className="row g-1 align-items-center">
            <div className="col-1 text-center">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans4.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans4.value === "1"}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
            </div>
            <div className="col-11">
              <img src={Imagen4} className="img-fluid" alt="Peruanos" />
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que a partir de la observación de imágenes sobre el Perú,
            se busca dar información sobre cómo es el territorio peruano.
          </li>
          <li>
            Lea la primera y la segunda indicación: Observa las imágenes de
            diferentes lugares del Perú. ¿Qué ves en cada una de ellas?
            Descríbelas siguiendo las indicaciones de tu profesor, profesora o
            familiar.
          </li>
          <li>
            Pida que observen los paisajes que se muestran y den detalles sobre
            ellos. Para ello, pídales que se fijen, por ejemplo, en lo
            siguiente:
            <ul>
              <li>
                <i>
                  “¿Cómo es el suelo del paisaje que se muestra en la imagen?
                  ¿Se trata de un terreno escarpado, plano, con vegetación, con
                  ríos o es arenoso?
                </i>
              </li>
              <li>
                <i>
                  ¿Cómo es el clima? ¿Será un clima frío o caluroso? - ¿Cómo es
                  la flora y la fauna del paisaje?”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora retome sus respuestas para la descripción de cada una de las
            imágenes. Puede realizar los siguientes comentarios:
            <ul>
              <li>
                <i>
                  “La primera imagen corresponde a un típico paisaje de puna.
                  Suele ser el paisaje de zonas con mucha altura, donde hace
                  mucho frío, hay nevados y poca vegetación. También encontramos
                  algunos auquénidos.
                </i>
              </li>
              <li>
                <i>
                  En la segunda imagen, vemos un paisaje presente en la costa
                  peruana. Es desértico, con dunas y el cielo nublado.
                </i>
              </li>
              <li>
                <i>
                  La tercera imagen corresponde a la selva amazónica. Vemos ahí
                  el río y la vegetación abundante.
                </i>
              </li>
              <li>
                <i>
                  En la cuarta imagen vemos un típico valle interandino. Es el
                  territorio que se encuentra entre las cordilleras y que es muy
                  productivo. En la imagen vemos cerros pequeños y áreas de
                  cultivo”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: ¿Cuáles de estos paisajes hay en tu
            departamento? Márcalos con un aspa. Dé un tiempo para que respondan.
            Pida sus respuestas y coméntelas de acuerdo con los paisajes que
            presenta el departamento en que se encuentran. Cierre la actividad
            resaltando la variedad de territorio del país:
            <ul>
              <li>
                <i>
                  “¿Los paisajes que hemos observado se asemejan o son muy
                  distintos entre sí? Son distintos y son una muestra de la
                  variedad de territorio que hay en nuestro país. Como veremos,
                  cada territorio tiene sus características propias. Las
                  personas se adaptan a estas características o las transforman
                  para poder vivir en espacios tan distintos.”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
